import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "modal fade",
  id: "editActivityConfirm",
  tabindex: "-1",
  "aria-labelledby": "editActivityConfirm",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-header" }
const _hoisted_5 = {
  class: "modal-title w-100 text-center fw-bold",
  id: "editActivityConfirm"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn-close",
  "data-bs-dismiss": "modal",
  "aria-label": "Close"
}, null, -1)
const _hoisted_7 = { class: "pb-3" }
const _hoisted_8 = { class: "text-center py-4 mb-4 border-bottom" }
const _hoisted_9 = { class: "row mx-0 px-0 d-flex justify-content-center flex-lg-row flex-column-reverse" }
const _hoisted_10 = { class: "col-lg-6 d-flex justify-content-lg-end justify-content-center" }
const _hoisted_11 = { class: "col-lg-6 d-flex justify-content-lg-start justify-content-center mb-4 mb-lg-0" }

import { ref, PropType, onMounted } from 'vue'
import { useStore } from 'vuex'
import { useRouter } from 'vue-router'
import dayjs from 'dayjs'

import { translate } from '@/languages/i18n'
import communityPortfoliosServices from '@/services/communities-portfolios.service'

import Button from '@/components/button/index.vue'

import { COMMUNITY_PORTFOLIOS_STORE } from '@/store/constants'
import { Modal } from 'bootstrap'


export default /*#__PURE__*/_defineComponent({
  props: {
  responseServerError: Function as PropType<() => void | undefined>,
  data: Object as PropType<{
    title: string | any
    fromDate: string
    toDate: string | any
    content: string | any
  }>,
  id: String,
  reset: {
    type: Function as PropType<() => void | undefined>,
  },
},
  emits: ['onHideModalConfirm'],
  setup(__props, { expose, emit }) {

const props = __props

const router = useRouter()
const store = useStore()




const submittingButton = ref<boolean>(false)
// 2022/09/13 TienNV Fix double click button confirm SG43
const modalSuccess = ref()
const modalConfirm = ref()
const getBack = ref(false)

onMounted(() => {
  const modal = document.getElementById('editActivityConfirm')
  modalSuccess.value = new Modal(document.getElementById('editActivityConfirmSuccess'))
  modalConfirm.value = new Modal(document.getElementById('editActivityConfirm'))
  modal?.addEventListener('hide.bs.modal', onHideModalConfirm)
})

expose({
  showConfirmModal: (): void => {
    getBack.value = false
    modalConfirm.value.show()
  },
})

const onSubmit = async (): Promise<void> => {
  submittingButton.value = true

  if (!props.id) {
    try {
      const response = await communityPortfoliosServices.createActivities({
        activity: {
          title: props.data?.title,
          start_period: dayjs(props.data?.fromDate).startOf('month').format('YYYY/MM/DD'),
          end_period: props.data?.toDate ? dayjs(props.data?.toDate).startOf('month').format('YYYY/MM/DD') : null,
          content: props.data?.content,
        },
        id: router.currentRoute.value.params.id,
      })

      if (response.status === 200) {
        localStorage.removeItem('checkConfirm')
        store.dispatch(COMMUNITY_PORTFOLIOS_STORE.ACTIONS.CREATE_ACTIVITIES_PORTFOLIOS, {
          title: props.data?.title,
          start_period: dayjs(props.data?.fromDate).startOf('month').format('YYYY/MM/DD'),
          end_period: props.data?.toDate ? dayjs(props.data?.toDate).startOf('month').format('YYYY/MM/DD') : null,
          content: props.data?.content,
          id: response.data.data?.portfolio_personal_activity_id,
        })
        // props.reset()
        props.responseServerError('')
        modalConfirm.value?.hide()
        modalSuccess.value?.show()
        setTimeout(() => {
          submittingButton.value = false
        }, 2000)
        return
      } else {
        // localStorage.setItem('serverError', true)
        props.responseServerError('create')
        modalConfirm.value?.hide()
        modalSuccess.value?.show()
        submittingButton.value = false
      }
    } catch (error) {
      console.log('err', error.response)
      // localStorage.setItem('serverError', true)
      modalConfirm.value?.hide()
      modalSuccess.value?.show()
      submittingButton.value = false
      props.responseServerError('create')
    }
  } else {
    try {
      const response = await communityPortfoliosServices.updateActivities({
        activity: {
          title: props.data?.title,
          start_period: dayjs(props.data?.fromDate).format('YYYY/MM/DD'),
          end_period: props.data?.toDate ? dayjs(props.data?.toDate).format('YYYY/MM/DD') : null,
          content: props.data?.content,
        },
        id: props.id,
      })

      if (response.status === 200) {
        localStorage.removeItem('checkConfirm')
        store.dispatch(COMMUNITY_PORTFOLIOS_STORE.ACTIONS.UPDATE_ACTIVITIES_PORTFOLIOS, {
          title: props.data?.title,
          start_period: dayjs(props.data?.fromDate).format('YYYY/MM/DD'),
          end_period: props.data?.toDate ? dayjs(props.data?.toDate).format('YYYY/MM/DD') : null,
          content: props.data?.content,
          id: props.id,
        })
        // props.reset()
        // 2022/09/13 TienNV Fix double click button confirm SG43
        modalConfirm.value?.hide()
        modalSuccess.value?.show()
        setTimeout(() => {
          submittingButton.value = false
        }, 2000)
        props.responseServerError('')

        return
      } else {
        // localStorage.setItem('serverError', true)
        props.responseServerError('update')
        modalConfirm.value?.hide()
        modalSuccess.value?.show()
        submittingButton.value = false
      }
      // 2022/09/13 TienNV Fix double click button confirm SG43
    } catch (error: any) {
      console.log('err', error.response)
      // localStorage.setItem('serverError', true)
      modalConfirm.value?.hide()
      modalSuccess.value?.show()
      submittingButton.value = false
      props.responseServerError('update')
    }
  }
}

const onHideModalConfirm = () => {
  emit('onHideModalConfirm', getBack.value)
}

const getBackConfirmModal = () => {
  getBack.value = true
  modalConfirm.value?.hide()
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h5", _hoisted_5, _toDisplayString(__props.id ? _unref(translate)('SG43editActivity') : _unref(translate)('SG43addActivity')), 1),
          _hoisted_6
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("form", {
            onSubmit: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["prevent"]))
          }, [
            _createElementVNode("div", _hoisted_8, _toDisplayString(_unref(translate)(!props.id ? 'SG43confirmActivity' : 'SG43confirmActivityEdit')), 1),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _createVNode(Button, {
                  title: _unref(translate)('back'),
                  type: 'secondary',
                  class: "me-lg-2",
                  onClick: getBackConfirmModal
                }, null, 8, ["title"])
              ]),
              _createElementVNode("div", _hoisted_11, [
                _createVNode(Button, {
                  class: "button-submit",
                  onClick: onSubmit,
                  title: __props.id ? '更新する' : '登録する',
                  loading: submittingButton.value,
                  disabled: submittingButton.value,
                  type: 'secondary'
                }, null, 8, ["title", "loading", "disabled"])
              ])
            ])
          ], 32)
        ])
      ])
    ])
  ]))
}
}

})